import { COOKIES } from '@/constants/cookies';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const manageAnonymousID = () => {
  let anonymousId = Cookies.get(COOKIES.NAMES.ANONYMOUS_ID);

  if (!anonymousId) {
    anonymousId = uuidv4();
    Cookies.set(COOKIES.NAMES.ANONYMOUS_ID, anonymousId, { expires: 365 });
    return anonymousId;
  }

  return anonymousId;
};

export const setAnonymousID = () => {
  if (typeof window === 'undefined') {
    return;
  }
  manageAnonymousID();
};
